import { formatDate } from "../../shared/CommonFunctions";

export interface ComponentHeaderProps {
  dateCreated?: string;
  userCreated?: string;
  editPath?: string;
  showEdit?: boolean;
  backPath?: string;
  showBack?: boolean;
  label?: string;
}

export default function componentProviderHeader({ dateCreated, userCreated, label }: ComponentHeaderProps) {
  return (
    <>
      <div className="w-full border-0 shadow-none comp-header">
        <div className="flex justify-content-between align-items-center w-full mb-3 border-purple border-2 text-purple font-bold flex-wrap header-height">
          <div>
            <h4 className="text-purple flex align-items-center">
              <span className="pl-1 mx-1 mt-0"></span>
              <span>{label}</span>
            </h4>
          </div>
          <div>
            {userCreated != null && (
              <>
                <span className="user-icon ml-3 pr-2"></span> <span> {userCreated}</span>
                <span className="time-stamp pr-2"></span> <span>{formatDate(dateCreated!)}</span>
              </>
            )}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
}
